import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ListItem from 'common/components/atoms/ListItem';

const FirmwareDeploymentListItem = styled(ListItem)`
  cursor: pointer;
  ${props => props.selected && 'background-color: rgba(145,184,70,0.08);'}
  td {
    height: 54px;
  }
`;

class FirmwareDeploymentItem extends React.Component {
  render() {
    const {
      item,
      columnSizes,
      onClick,
      selected,
      t
    } = this.props;
    return (
      <>
      <FirmwareDeploymentListItem selected={selected} onClick={() => onClick(item.id)}>
          <td width={`${columnSizes[0]}%`}>
            {item.id || '--'}
          </td>
          <td width={`${columnSizes[1]}%`}>
            {item.name || '--'}
          </td>
          <td width={`${columnSizes[2]}%`}>
            {item.firmware_type
              ? t(`firmwareDeployment.firmwareType.${item.firmware_type}`, { defaultValue: item.firmware_type })
              : '--'}
          </td>
          <td width={`${columnSizes[3]}%`}>
            {item.association_type
              ? t(`firmwareDeployment.associationType.${item.association_type}`, { defaultValue: item.association_type })
              : '--'}
          </td>
          <td width={`${columnSizes[4]}%`}>
            {item.target_version || '--'}
          </td>
          <td width={`${columnSizes[5]}%`}>
            {item.account_name || '--'}
          </td>
      </FirmwareDeploymentListItem>
      </>
    );
  }
}

FirmwareDeploymentItem.propTypes = {
  item: PropTypes.object.isRequired,
  columnSizes: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

// withRef: the generic List attaches a ref to each item component.
export default withTranslation(undefined, { withRef: true })(FirmwareDeploymentItem);
